import React, { Component } from "react";
import { connect } from "react-redux";
import { addNewManagedApp } from "../redux/actions/appActions";
import { withRouter } from "react-router-dom";


import Dialog from "@material-ui/core/Dialog";
import { DialogTitle } from "../components/DialogTitle";
import { DialogContent } from "../components/DialogContent";
import Typography from "@material-ui/core/Typography";
import { withStyles } from "@material-ui/core/styles";

import Button from "@material-ui/core/Button";
import StyledDropzone from '../components/StyledDropzone'

import AppInfoParser from 'app-info-parser';

import _ from 'lodash';
import { ShowHide } from '../components/ShowHide';


import { getCurrentUserOrganizationRef } from '../redux/actions/utils';

const styles = theme => ({
  root: {
    bottom: theme.spacing(1)
  },
  divider: {
    color: theme.palette.primary.main
  },
  dropzoneContainer: {
    marginBottom: '20px'
  },
  fileChosen: {
    color: theme.palette.primary.dark
  },
  submitButton: {
    float: 'right'
  },
  error: {
    color: theme.palette.primary.error
  }
});

export class AddManagedApp extends Component {

  constructor(props) {
    super(props);
    this.state = {
      apkFile: null,
      obbFile: null,
      error: null,
      newAppData: null,
      processing: false,
      canSubmit: false
    };
  }

  getNewAppData = (apkManifestData) => {
    let appsWithPackageName = _.filter(Object.values(this.props.apps), {
      packageName: apkManifestData.package,
      _organizationId: getCurrentUserOrganizationRef().id
    });

    let appData = {
      packageName: apkManifestData.package,
      latestVersion: apkManifestData.versionCode,
      versionName: apkManifestData.versionName,
      title: _.get(apkManifestData, 'application.label[0]', 'Default App Name')
    }

    if (appsWithPackageName.length > 0) {
      let appsWithSameVersion = _.filter(appsWithPackageName, {
        latestVersion: apkManifestData.versionCode,
        versionName: apkManifestData.versionName
      });

      if (appsWithSameVersion.length > 0) {
        return { error: `The same app with Package Name [${apkManifestData.package}], Version Code [${apkManifestData.versionCode}], and Version Name [${apkManifestData.versionName}] has already been uploaded. Please try a different APK file.` };
      }

      appsWithPackageName = _.sortBy(appsWithPackageName, ['versionCode', 'versionName'])
      let latestApp = appsWithPackageName[appsWithPackageName.length - 1];
      appData = {
        ...appData,
        title: latestApp.title,
        iconUrl: latestApp.iconUrl,
        description: latestApp.description,
        categories: latestApp.categories,
        vrTypes: latestApp.vrTypes,
        showInLaunchers: latestApp.showInLaunchers,
        sortPriority: latestApp.sortPriority,
        defaultPlatformAdminApp: latestApp.defaultPlatformAdminApp,
        globalAccess: latestApp.globalAccess
      };
    }

    return appData;
  }

  onApkFileChange = apkFile => {
    apkFile = apkFile[0];
    this.setState({ apkFile, processing: true, canSubmit: false, error: null, newAppData: null });

    const parser = new AppInfoParser(apkFile);
    parser.parse().then(apkManifestData => {
      // console.log('app info ----> ', apkManifestData)
      // console.log('icon base64 ----> ', result.icon)
      let newAppData = this.getNewAppData(apkManifestData);
      if (newAppData.error) {
        this.setState({ error: newAppData.error, canSubmit: false, processing: false });
      } else {
        this.setState({ canSubmit: true, processing: false, newAppData });
      }
    }).catch(err => {
      console.error('err ----> ', err)
      this.setState({ error: err, canSubmit: false, processing: false });
    });
  };

  onObbFileChange = obbFile => {
    obbFile = obbFile[0];
    this.setState({ obbFile });
  }

  onSubmit = _ => {
    const { onClose, addNewManagedApp, history } = this.props;
    addNewManagedApp(this.state.apkFile, this.state.obbFile, this.state.newAppData, history);
    onClose();
  }

  render() {
    const { onClose, classes } = this.props;
    return (
      <Dialog
        maxWidth="sm"
        fullWidth={true}
        scroll="body"
        open
        spacing={0}
        className={classes.root}
        onClose={onClose}
      >
        <DialogTitle onCancel={onClose}>New Managed App</DialogTitle>
        <DialogContent>

          <div className={classes.content}>
            <StyledDropzone className={classes.dropzoneContainer} accept=".apk" multiple={false} onDrop={this.onApkFileChange} acceptedFile={!!this.state.apkFile}>
              {this.state.apkFile ? <p className={classes.fileChosen}><b>APK:</b> {this.state.apkFile.name}</p> : <p>Upload an APK</p>}
              <Typography variant="caption">Required</Typography>
            </StyledDropzone>

            <StyledDropzone className={classes.dropzoneContainer} accept=".obb" multiple={false} onDrop={this.onObbFileChange}>
              {this.state.obbFile ? <p className={classes.fileChosen}><b>OBB:</b> {this.state.obbFile.name}</p> : <p>Upload an OBB</p>}
              <Typography variant="caption">Optional</Typography>
            </StyledDropzone>

            <ShowHide show={this.state.error}>
              <Typography variant="caption" className={classes.error}>
                {this.state.error}
              </Typography>
            </ShowHide>

            <Button
              variant="contained"
              component="span"
              color="primary"
              className={classes.submitButton}
              onClick={this.onSubmit}
              disabled={!this.state.canSubmit}
            >
              Submit
            </Button>
          </div>
        </DialogContent>
      </Dialog>
    );
  }
}

const mapStateToProps = state => ({
  apps: state.data.apps
});

const mapDispatchToProps = {
  addNewManagedApp
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(withRouter(AddManagedApp)));
